module.exports = __webpack_public_path__ + "img/about-main-mob.822e125f.webp";